import { render, staticRenderFns } from "./examVieweight.vue?vue&type=template&id=09ae919a&scoped=true"
import script from "./examVieweight.vue?vue&type=script&lang=js"
export * from "./examVieweight.vue?vue&type=script&lang=js"
import style0 from "./examVieweight.vue?vue&type=style&index=0&id=09ae919a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ae919a",
  null
  
)

export default component.exports